<template>
    <modal size="lg" @close="reset(); $emit('close')" :height-max="true" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Add Pay Group Collection</h3>
        </template>

        <slot>
            <div v-show="step == 'name'">
                <div class="form-row">
                    <div class="col">
                        <form-input label="Collection Name" v-model="formData.name" :errors="errors.name" type="text" :maxlength="128" />
                    </div>
                </div>
            </div>

            <div v-if="step == 'paygroups'">
                <paygroup-selector
                    :client="client"
                    v-model="formData.paygroups"
                />
            </div>
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button v-if="step == 'name'" type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>
                <button v-if="step == 'paygroups'" type="button" class="btn btn-outline-primary" @click.prevent="previousStep">
                    Back
                </button>
                <button v-if="step == 'name'" type="button" class="btn btn-primary" @click.prevent="nextStep">
                    Next
                </button>
                <button v-if="step == 'paygroups'" type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import PaygroupSelector from '@/pages/client/Settings/components/PaygroupSelector'

export default {
    props: ['client', ],
    mixins: [FormMixin, ModalMixin],
    components: {PaygroupSelector, },
    emits: ['updated', 'close', ],
    mounted() {
    },
    data() {
        return {
            formData: this.makeFormData(),
            step: 'name',
        }
    },
    computed: {},
    methods: {
        makeFormData() {
            return {
                name: '',
                paygroups: [],
            }
        },
        previousStep() {
            if (this.step == 'paygroups') {
                this.step = 'name'
            }
        },
        nextStep() {
            this.formErrors = []
            if (!this.validate()) {
                return
            }

            if (this.step == 'name') {
                this.step = 'paygroups'
            }
        },
        onSubmit() {
            if (!this.validate()) {
                return
            }

            this.$store.dispatch('START_LOADING')
            const url = `/clients/${this.client.id}/settings/paygroup-collections`
            this.$api.post(url, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo(`Successfully added pay group collection.`)
                this.$emit('updated')
                this.close()
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.formErrors = (errors.__all__ || [])
                this.$bus.showError(errors.__all__)
            })
        }
    }
}
</script>
